export const FETCH_CATALOG_REQUEST = "dashboard/FETCH_CATALOG_REQUEST";
export const FETCH_CATALOG_SUCCESS = "dashboard/FETCH_CATALOG_SUCCESS";
export const FETCH_CATALOG_FAILURE = "dashboard/FETCH_CATALOG_FAILURE";

export const fetchCatalogRequest = () => ({ type: FETCH_CATALOG_REQUEST });
export const fetchCatalogSuccess = (data) => ({ type: FETCH_CATALOG_SUCCESS, payload: { data } });
export const fetchCatalogFailure = (error) => ({ type: FETCH_CATALOG_FAILURE, payload: { error } });
